import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import './DashboardErrorBoundary.css';

const DashboardErrorFallback = ({ error, onReset }) => (
  <div className="dashboard-error-boundary-container">
    <div className="dashboard-error-boundary-content">
      <div className="dashboard-error-boundary-icon">
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 13H11L13 17H21L19 13H17L15 9H13L11 13H3ZM12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      
      <h3 className="dashboard-error-boundary-title">Dashboard Error</h3>
      
      <p className="dashboard-error-boundary-message">
        There was an error loading the dashboard content. This might be due to data loading issues or a temporary problem.
      </p>
      
      <div className="dashboard-error-boundary-actions">
        <button 
          onClick={() => window.history.back()}
          className="dashboard-error-boundary-back-button"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H6M6 12L11 7M6 12L11 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Go Back
        </button>
        
        <button 
          onClick={onReset}
          className="dashboard-error-boundary-retry-button"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4V10H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M23 20V14H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Retry
        </button>
      </div>
    </div>
  </div>
);

const DashboardErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary fallback={DashboardErrorFallback}>
      {children}
    </ErrorBoundary>
  );
};

export default DashboardErrorBoundary;